class Axis {

	constructor(isPrimary) {
		this.config = {
			min: null,
			max: null,
			tickValues: null,
			formatters: [
				value => value
			],
			constraints: null,
			isPrimary: isPrimary
		};
	}

	tickValues(tickValues) {
		this.config.tickValues = tickValues;
		return this;
	}

	formatter(formatter1, formatter2) {
		// For a dual axis, 2 formatters can be provided. The first one will be applied to
		// the left side and the second one to the right side.
		this.config.formatters = formatter2 ? [formatter1, formatter2] : [formatter1];
		return this;
	}

	/**
	 * Apply constraints to the axis, passed into the algorithm for calculating tick values.
	 * @param constraints
	 *
	 * Constraints is an object containing any subset of below fields:
	 * {
	 *     fixedMinValue: number,
	 *     fixedMaxValue: number,
	 *     lowestMinValue: number,
	 *     highestMinValue: number,
	 *     lowestMaxValue: number,
	 *     highestMaxValue: number,
	 *     stepOptions: number[],
	 *     fixedNumberOfTicks: number
	 * }
	 */
	constraints(constraints) {
		this.config.constraints = constraints;
		return this;
	}

}

export function yAxis(isPrimary = false) {
	return new Axis(isPrimary);
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/axis-y.js